var map = {
	"./Frame 62566828.png": 967,
	"./Union.png": 714,
	"./Union2.png": 679,
	"./Union3.png": 334,
	"./Vector.png": 214,
	"./Vector2.png": 831,
	"./Vector3.png": 803,
	"./Vector4.png": 929,
	"./bank.png": 739,
	"./bank2.png": 470,
	"./close.png": 460,
	"./dax.png": 839,
	"./dollar.png": 134,
	"./eu.png": 593,
	"./gas.png": 252,
	"./logo.png": 949,
	"./person.png": 641,
	"./person2.png": 485,
	"./person3.png": 981,
	"./popup.png": 359,
	"./sp500.png": 522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;